import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../lib/axios";
import { API_PORTAL_URL } from "../lib/config";

export interface IOffer {
  ID: number;
  Title: string;
  ShortDescription?: string;
  LongDescription?: string;
  URL?: string;
  Url?: string;
  MetaTitle?: string;
  MetaKeywords?: string;
  MetaDescription?: string;
  TermsAndCondition?: string;
  Images?: string;
  BannerImage?: string;
  IsDisplayHome?: boolean;
  IsActive?: boolean;
  Price?: string;
  ValidTill?: string;
  Inclusions?: string[];
}

export interface OfferState {
  loading: boolean;
  error: string;
  offerDetails: IOffer | null;
  OfferList: IOffer[];
}

export const getAllActiveOffers = createAsyncThunk(
  "Offer/FindAllActiveOffer",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Offer/FindAllActiveOffer`
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Offers:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getOfferByURL = createAsyncThunk(
  "Offer/FindByURLOffer",
  async (url: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Offer/FindByURLOffer`,
        { URL: url, Url: url }
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error fetching Offer detail:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

const initialState: OfferState = {
  loading: false,
  error: "",
  offerDetails: null,
  OfferList: [],
};

const offerSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllActiveOffers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveOffers.fulfilled, (state, action) => {
      state.loading = false;
      state.OfferList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveOffers.rejected, (state, action) => {
      state.loading = false;
      state.OfferList = [];
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getOfferByURL.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOfferByURL.fulfilled, (state, action) => {
      state.loading = false;
      state.offerDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getOfferByURL.rejected, (state, action) => {
      state.loading = false;
      state.offerDetails = null;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default offerSlice.reducer;
